import { render, staticRenderFns } from "./productsView.vue?vue&type=template&id=36cf4eee"
import script from "./productsView.vue?vue&type=script&lang=js"
export * from "./productsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports